exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.push([module.id, "@import url(https://use.typekit.net/srv0wme.css);", ""]);

// module
exports.push([module.id, "/*\r\n$breakpoint argument choices:\r\n- xs\r\n- sm\r\n- md\r\n- lg\r\n- xl\r\n*/\n.searchCompact[data-v-76cd8b34] {\n  position: absolute;\n  right: 65px;\n  color: #b6b6b6;\n}\n", ""]);

// exports
